"use client";
import { Link } from "@/components/ui/link";
import { client } from "@/sanity/lib/client";
import { getCategoriesQuery } from "@/sanity/lib/queries";
import { PostCategoryType } from "@/types/PostTypes";
import { cn } from "@/utils";
import { usePathname } from "next/navigation";
import useSWR from "swr";

async function getCategories(): Promise<PostCategoryType[]> {
  return client.fetch(getCategoriesQuery);
}

export const PostCategories = () => {
  const currentPath = usePathname();
  const {
    data: categories,
    error,
    isLoading,
  } = useSWR(getCategoriesQuery, getCategories);

  const isActiveCategory = (categorySlug: string) => {
    return currentPath.startsWith(`/category/${categorySlug}`);
  };

  if (isLoading) {
    return <CategorySkeleton />;
  }

  return (
    <aside className="sticky top-0 hidden h-fit overflow-y-auto pr-4 lg:block lg:w-2/12">
      <ul className="flex flex-col">
        <li>
          <Link
            href="/blog"
            className={cn(
              currentPath.startsWith("/blog") &&
                "font-bold text-blue-600 dark:text-blue-500",
            )}
          >
            All posts
          </Link>
        </li>
        {categories?.map((category: PostCategoryType) =>
          category.totalPosts > 0 ? (
            <li key={category._id} className="ml-2">
              <Link
                href={`/category/${category.slug}`}
                className={cn(
                  isActiveCategory(category.slug) &&
                    "font-bold text-blue-600 dark:text-blue-500",
                )}
              >
                {category.title} ({category.totalPosts})
              </Link>
            </li>
          ) : null,
        )}
      </ul>
    </aside>
  );
};

const CategorySkeleton = () => {
  const widths = ["w-1/2", "w-3/4", "w-5/6", "w-2/3", "w-1/4"];
  return (
    <aside className="sticky top-0 hidden h-fit overflow-y-auto pr-4 lg:block lg:w-2/12">
      <ul className="flex flex-col">
        {widths.map((width, index) => (
          <li className="animate-pulse" key={index}>
            <div
              className={cn(`h-4 rounded-sm bg-gray-300 ${width} mb-3`)}
            ></div>
          </li>
        ))}
      </ul>
    </aside>
  );
};
